<template>
  <div>
    <apexchart
      width="50%"
      type="radar"
      :options="options"
      :series="series">
    </apexchart>
  </div>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  components: {
    apexchart: VueApexCharts
  },

  data() {
    return {
      options: {
        /*
        chart: {
          id: 'vuechart-example'
        },
        */
        title: {
            text: 'Esempio grafico a ragnatela'
        },
        plotOptions: {
            radar: {
                // size: 4,
                polygons: {
                    strokeColor: '#e9e9e9',
                    fill: {
                        colors: ['#f8f8f8', '#fff']
                    }
                }
            }
        },
        labels: ['Prevenzione', 'Protezione', 'Trasferimento'],
        yaxis: {
          min: 0,
          max: 5,
          tickAmount: 5
        },
      },
      series: [
        {
          name: 'Impatto sui costi',
          data: [2, 4, 3],
        },
        {
          name: 'Impatto sui ricavi',
          data: [1, 3, 2],
        },
        {
          name: 'Impatto sui giorni di fermo',
          data: [4, 1, 4],
        },
      ],
    }
  }
};
</script>
